export const SIGNUP_NEW_PASSWORD_INITIALIZED = 'signup/NEW_PASSWORD_INITIALIZED';
export const SIGNUP_NEW_PASSWORD_SAVED = 'signup/NEW_PASSWORD_SAVED';
export const SIGNUP_PROFILE_INITIALIZED = 'signup/PROFILE_INITIALIZED';
export const SIGNUP_PROFILE_SAVED = 'signup/PROFILE_SAVED';
